import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReadMore(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5ZM4 6a1 1 0 0 1 1-1h4v14H5a1 1 0 0 1-1-1V6Zm7 13h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-8v14Z"
      />
      <path
        fill="currentColor"
        d="M14 15h3a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2ZM14 11h3a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2ZM14 7h3a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2Z"
      />
    </BaseIcon>
  );
}
